"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ClayAutocomplete = void 0;
var _form = require("@clayui/form");
var _shared = require("@clayui/shared");
var _react = _interopRequireDefault(require("react"));
var _Autocomplete = require("./Autocomplete");
var _Context = require("./Context");
var _DropDown = _interopRequireDefault(require("./DropDown"));
var _Input = _interopRequireDefault(require("./Input"));
var _Item = _interopRequireDefault(require("./Item"));
var _LoadingIndicator = _interopRequireDefault(require("./LoadingIndicator"));
var _excluded = ["children"],
  _excluded2 = ["children", "className", "component"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var AutocompleteMarkup = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_form.ClayInput.Group, _extends({}, otherProps, {
    ref: ref
  }), /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupItem, null, children));
});
AutocompleteMarkup.displayName = 'ClayAutocompleteMarkup';

/**
 * Temporary helper function to determine which version of autocomplete
 * is being used.
 */
var hasItems = function hasItems(children) {
  if (!children) {
    return [];
  }
  return _react.default.Children.map(children, function (child) {
    if (/*#__PURE__*/_react.default.isValidElement(child) &&
    // @ts-ignore
    child.type.displayName === 'Item') {
      return true;
    }
    return false;
  }).filter(Boolean);
};
var ClayAutocomplete = exports.ClayAutocomplete = /*#__PURE__*/_react.default.forwardRef(function AutocompleteInner(_ref2, _ref3) {
  var children = _ref2.children,
    className = _ref2.className,
    _ref2$component = _ref2.component,
    Component = _ref2$component === void 0 ? AutocompleteMarkup : _ref2$component,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  var containerElementRef = _react.default.useRef(null);
  var _React$useState = _react.default.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    loading = _React$useState2[0],
    setLoading = _React$useState2[1];
  var isNewBehavior = hasItems(children).length >= 1 || children instanceof Function;
  var Container = isNewBehavior ? _react.default.Fragment : _shared.FocusScope;
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(Component, _extends({}, isNewBehavior ? {} : otherProps, {
    className: className,
    ref: function ref(r) {
      if (r) {
        containerElementRef.current = r;
        if (typeof _ref3 === 'function') {
          _ref3(r);
        } else if (_ref3 !== null) {
          _ref3.current = r;
        }
      }
    }
  }), isNewBehavior ? /*#__PURE__*/_react.default.createElement(_Autocomplete.Autocomplete, _extends({
    containerElementRef: containerElementRef
  }, otherProps), children) : /*#__PURE__*/_react.default.createElement(_Context.LegacyContext.Provider, {
    value: {
      containerElementRef: containerElementRef,
      loading: loading,
      onLoadingChange: function onLoadingChange(loading) {
        return setLoading(loading);
      }
    }
  }, children)));
});
var _default = exports.default = Object.assign(ClayAutocomplete, {
  DropDown: _DropDown.default,
  Input: _Input.default,
  Item: _Item.default,
  LoadingIndicator: _LoadingIndicator.default
});